module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tat-dashboard-container"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dashboard-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-stats"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('span', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.totalData))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Total Jobs")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card green"
  }, [_c('span', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.getStatusCount('green')))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("On Track")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card red"
  }, [_c('span', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.getStatusCount('red')))]), _vm._v(" "), _c('span', {
    staticClass: "stat-label"
  }, [_vm._v("Delayed")])])])])]), _vm._v(" "), _c('b-card', {
    staticClass: "main-content-card"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.search_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "search_txt", $$v)
      },
      expression: "Filter.search_txt"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.Filter.search_txt
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    class: ' pull-right mb-1' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.PrealertFilter ||
        _vm.Filter.SOBFilter ||
        _vm.Filter.isFinalBillingStatus ||
        _vm.Filter.booking_number ||
        _vm.Filter.container_number ||
        _vm.Filter.MblNoFilter ||
        _vm.Filter.HblNoFilter ||
        _vm.Filter.assignmentFilter ||
        _vm.Filter.dateStatusFilter ||
        _vm.Filter.billingFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.liner_bl_release_statusFilter ||
        _vm.Filter.line_inv_statusFilter ||

        _vm.Filter.search_txt ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.PrealertFilter ||
    _vm.Filter.SOBFilter ||
    _vm.Filter.isFinalBillingStatus ||
    _vm.Filter.booking_number ||
    _vm.Filter.container_number ||
    _vm.Filter.MblNoFilter ||
    _vm.Filter.HblNoFilter ||
    _vm.Filter.assignmentFilter ||
    _vm.Filter.dateStatusFilter ||
    _vm.Filter.billingFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.liner_bl_release_statusFilter ||
    _vm.Filter.line_inv_statusFilter ||

    _vm.Filter.search_txt ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.JOBList && _vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Booking NO Filter",
      "id": "booking_number",
      "name": "booking_number",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.booking_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "booking_number", $$v)
      },
      expression: "Filter.booking_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container No Filter",
      "id": "container_number",
      "name": "container_number",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.container_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "container_number", $$v)
      },
      expression: "Filter.container_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MBL No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search MBL No Filter",
      "id": "MblNoFilter",
      "name": "MblNoFilter",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.MblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "MblNoFilter", $$v)
      },
      expression: "Filter.MblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("HBL No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search HBL No Filter",
      "id": "HblNoFilter",
      "name": "HblNoFilter",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.HblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HblNoFilter", $$v)
      },
      expression: "Filter.HblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job No Filter",
      "id": "assignmentFilter",
      "name": "assignmentFilter",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.assignmentFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentFilter", $$v)
      },
      expression: "Filter.assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Months/Year")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Invoice Status",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateStatusFilter", $$v)
      },
      expression: "Filter.dateStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Invoice Status",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.isFinalBillingStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isFinalBillingStatus", $$v)
      },
      expression: "Filter.isFinalBillingStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Invoice Status",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.billingFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billingFilter", $$v)
      },
      expression: "Filter.billingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Sob Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Sob Status",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.SOBFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SOBFilter", $$v)
      },
      expression: "Filter.SOBFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Prealert Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PrealertStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Prealert Status",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PrealertFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PrealertFilter", $$v)
      },
      expression: "Filter.PrealertFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "search_txt",
      "name": "search_txt",
      "autocomplete": "off",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.search_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "search_txt", $$v)
      },
      expression: "Filter.search_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User",
      "disabled": _vm.isLoading
    },
    on: {
      "input": function($event) {
        _vm.fetchTATData('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Liner BL Release Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mblInvoiceStatus,
      "id": "liner_bl_release_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select MBL Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.liner_bl_release_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "liner_bl_release_statusFilter", $$v)
      },
      expression: "Filter.liner_bl_release_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Line Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.lineInvoiceStatus,
      "id": "line_inv_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Line Invoice Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.line_inv_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "line_inv_statusFilter", $$v)
      },
      expression: "Filter.line_inv_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header bg-primary text-white"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', {
    staticClass: "h6 mb-0"
  }, [_vm._v("\n              Total Records: " + _vm._s(_vm.JOBList && _vm.JOBList.length || 0) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body p-0"
  }, [(_vm.JOBList && _vm.JOBList.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.JOBList,
      "fields": _vm.tableFields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "tbody-tr-class": _vm.rowClass,
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "busy": _vm.isLoading
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "tatAnalysis",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Inv Upload:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-sm ml-1 badge-secondary"
        }, [_vm._v("\n                      " + _vm._s(data.item.InvUploadTatSobPlusOneDays || 0) + "d\n                    ")])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("MBL Release:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-sm ml-1 badge-secondary"
        }, [_vm._v("\n                      " + _vm._s(data.item.MblReleaseTatSobPlusTwoDays || 0) + "d\n                    ")])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Accounts:     "), _c('span', {
          staticClass: "badge badge-sm ml-1 badge-secondary"
        }, [_vm._v(" " + _vm._s(data.item.DaysFromMBLToSendToAccounts || 0) + "d ")])]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Payment:      "), _c('span', {
          staticClass: "badge badge-sm ml-1 badge-secondary"
        }, [_vm._v(_vm._s(data.item.OEPaymentFirstSob || 0) + "d ")])]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("File Close:      "), _c('span', {
          staticClass: "badge badge-sm ml-1 badge-secondary"
        }, [_vm._v(_vm._s(data.item.TatForFileClosingMblReleasePlusFourDays || 0) + "d ")])])]) : _vm._e()]
      }
    }, {
      key: "jobDetails",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                    " + _vm._s(data.item.JobNo) + "\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-wrap gap-1 mb-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(_vm.formatDate(data.item.JobDate)))]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.JobType))])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.TransportType) + " | " + _vm._s(data.item.FclLcl))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Mode:")]), _vm._v(" " + _vm._s(data.item.Mode))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Code:")]), _vm._v(" " + _vm._s(data.item.JobCode))])])]) : _vm._e(), _vm._v(" "), (data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                    " + _vm._s(_vm.truncateText(data.item.ShippingLine, 20)) + "\n                  ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(data.item.BookingNo))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(data.item.FreightContainersType))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Count:")]), _vm._v(" " + _vm._s(data.item.MultipleContainerNo))])])]) : _vm._e(), _vm._v(" "), (data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                    " + _vm._s(_vm.truncateText(data.item.ClientName, 25)) + "\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "text-muted"
        }, [_vm._v("\n                    " + _vm._s(data.item.RaisedFrom) + "\n                  ")]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("By: " + _vm._s(data.item.RaisedBy))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Billing:")]), _vm._v(" " + _vm._s(data.item.billingType))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("User:")]), _vm._v(" " + _vm._s(data.item.SentToAccountsUser))])])]) : _vm._e()]
      }
    }, {
      key: "route",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('span', {
          staticClass: "badge badge-light"
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.POR)))]), _vm._v(" "), _c('span', {
          staticClass: "mx-1 text-muted"
        }, [_vm._v("→")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light"
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.POL)))]), _vm._v(" "), _c('span', {
          staticClass: "mx-1 text-muted"
        }, [_vm._v("→")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-light"
        }, [_vm._v(_vm._s(_vm.getPortCode(data.item.POD)))])]), _vm._v(" "), (data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                      Vessel / Voyage: " + _vm._s(data.item.VesselVoyage || 'N/A') + "\n                    ")]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.Mode) + " | " + _vm._s(data.item.FclLcl &&
          data.item.FclLcl.toUpperCase()))]), _vm._v(" "), _c('div', {
          staticClass: "mt-1"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("SOB:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.Sob))])]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_c('strong', [_vm._v("Overseas:")]), _vm._v(" " + _vm._s(data.item.closedOverseasStatus))])])]) : _vm._e(), _vm._v(" "), _c('small', {
          staticClass: "text-muted mt-1"
        }, [_c('strong', [_vm._v("Terms:")]), _vm._v(" " + _vm._s(data.item.DeliveryTerms))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted d-block"
        }, [_c('strong', [_vm._v("Contract:")]), _vm._v(" " + _vm._s(data.item.ContractNo || 'N/A'))])]) : _vm._e()]
      }
    }, {
      key: "documents",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("MBL:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_vm._v(_vm._s(data.item.MblNo || 'N/A'))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("HBL:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_vm._v(_vm._s(data.item.HblNo || 'N/A'))])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("SB: " + _vm._s(data.item.ShippingBillNo || 'N/A'))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Invoice: " + _vm._s(data.item.ShipperInvNo || 'N/A'))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("MBL Date: "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.MblReleaseDate ||
          'N/A'))])])]) : _vm._e()]
      }
    }, {
      key: "additionalInfo",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("User:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_vm._v(_vm._s(data.item.SentToAccountsUser || 'N/A'))])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Billing:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_vm._v(_vm._s(data.item.billingType || 'N/A'))])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("BL Status: " + _vm._s(data.item.BlReleaseStatus || 'N/A'))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Sline Pay: " + _vm._s(data.item.SlinePaymentStatus || 'N/A'))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Prealert: " + _vm._s(data.item.PrealertStatus || 'N/A'))])]) : _vm._e()]
      }
    }, {
      key: "billingAccounts",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [(data.item.HblReleaseDate) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("HBL Release:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.HblReleaseDate))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Sline Req:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.SlineInvoiceRequestDate ||
          'N/A'))])])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("MBL Release Date:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.MblReleaseDate || 'N/A'))])])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Accounts User: " + _vm._s(data.item.SentToAccountsUser || 'N/A'))]), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Sent Date: "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.SentToAccountsDate || 'N/A'))])]), _c('br')]) : _vm._e()]
      }
    }, {
      key: "submissions",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("VGM:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.VgmSubmissionDateActual ||
          'N/A'))])])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("SI:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.SiSubmissiondateActual ||
          'N/A'))])])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("TR:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.TrSubmissiondateActual ||
          'N/A'))])])]), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Handover:")]), _vm._v(" "), _c('span', {
          staticClass: "ml-1"
        }, [_c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.HandoverDateActual || 'N/A'))])])])]) : _vm._e()]
      }
    }, {
      key: "completeData",
      fn: function(data) {
        return [(data.item) ? _c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('h6', {
          staticClass: "mb-2"
        }, [_vm._v("\n                    Additional Fields\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-column"
        }, [(data.item.HblReleaseDate) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("HBL Release:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.HblReleaseDate))])]) : _vm._e(), _vm._v(" "), (data.item.HblReleaseTatSobPlusOneDays) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("HBL TAT:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.HblReleaseTatSobPlusOneDays) + "d")])]) : _vm._e(), _vm._v(" "), (data.item.BillingInvTatFromClosingMblPlusTwoDays) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Billing TAT:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.BillingInvTatFromClosingMblPlusTwoDays) + "d")])]) : _vm._e(), _vm._v(" "), (data.item.TatForFileClosingMblReleasePlusFourDays) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("File Closing TAT:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.TatForFileClosingMblReleasePlusFourDays) + "d")])]) : _vm._e(), _vm._v(" "), (data.item.RInvNo) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Reverse Tally:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.RInvNo))])]) : _vm._e(), _vm._v(" "), (data.item.ReverseTallyInvDate) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Rev Tally Date:")]), _vm._v(" "), _c('span', {
          staticClass: "badge badge-secondary"
        }, [_vm._v(_vm._s(data.item.ReverseTallyInvDate))])]) : _vm._e(), _vm._v(" "), (data.item.OEPaymentFirstSob !== null) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("OE Payment:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.OEPaymentFirstSob) + "d")])]) : _vm._e(), _vm._v(" "), (data.item.DaysFromOEPaymentFirst) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Days from OE:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.DaysFromOEPaymentFirst) + "d")])]) : _vm._e(), _vm._v(" "), (data.item.frghtTermsHbl) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Freight Terms HBL:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.frghtTermsHbl))])]) : _vm._e(), _vm._v(" "), (data.item.frghtTermsMbl) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Freight Terms MBL:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.frghtTermsMbl))])]) : _vm._e(), _vm._v(" "), (data.item.status_verbose) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Status Verbose:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.status_verbose))])]) : _vm._e(), _vm._v(" "), (data.item.IsRollover) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Rollover:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.IsRollover))])]) : _vm._e(), _vm._v(" "), (data.item.IsManifestation) ? _c('div', {
          staticClass: "d-flex justify-content-between mb-1"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Manifestation:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.item.IsManifestation))])]) : _vm._e()])]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  }), _vm._v(" "), _c('strong', [_vm._v("Loading...")])], 1)])], 2)], 1) : _c('div', {
    staticClass: "text-center py-5"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x text-muted mb-3"
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-muted"
  }, [_vm._v("No Jobs Found")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("There are no jobs to display at the moment.")])])])]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "dashboard-title"
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  }), _vm._v("\n        TAT Dashboard\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db33594","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/TATDashboard.vue
// module id = 2669
// module chunks = 0